import React from "react";
import { Link } from "react-router-dom";
import path from "../../routes/path";
import './static/Footer.scss'
import siteConfig from "../../config/site-config";
import { returnNumberByLang } from "../../helper/CommonFunctions";
import { useTranslation } from 'react-i18next';
import BackToTop from "../backToTop/BackToTop";
import { useSelector } from "react-redux";

const Footer = () => {
    const { t } = useTranslation();
    const contactUsData = useSelector((state) => state.userReducer.contactData);

    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        {/* Single */}
                        <div className="col-lg-3 col-sm-12">
                            <div className="footer-widgets-single">
                                <div className="f-logo">
                                    <Link to={`${process.env.PUBLIC_URL}${path.home}`}>
                                        <img src={siteConfig.company_logo2} alt={siteConfig.company_name} />
                                    </Link>
                                </div>
                                {/* <p>{t('footer.content',{ company_name: siteConfig.company_name})}</p> */}
                                <div className="f-social">
                                    <span><a className="facebook" href={siteConfig.site_social_fb_link} target='__blank'><i className="fab fa-facebook-f"></i></a></span>
                                    <span><a className="youtube" href={siteConfig.site_social_youtube_link} target='__blank'><i className="fa-brands fa-youtube"></i></a></span>
                                    <span><a className="twitter" href={siteConfig.site_social_twitter_link} target='__blank'><i className="fa-brands fa-x-twitter"></i></a></span>
                                    <span><a className="instagram" href={siteConfig.site_social_instagram_link} target='__blank'><i className="fa-brands fa-instagram"></i></a></span>
                                </div>
                            </div>
                        </div>
                        {/* Single */}
                        <div className="col-lg-3 col-sm-4 col-6">
                            <div className="footer-widgets-single">
                                <h4>{t('footer.policies')}</h4>
                                <ul>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.terms_of_service}`}>{t('footer.terms_of_service')}</Link>
                                    </li>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.refund_policy}`}>{t('footer.refund_policy')}</Link>
                                    </li>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.privacy_policy}`}>{t('footer.privacy_policy')}</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Single */}
                        <div className="col-lg-3 col-sm-4 col-6">
                            <div className="footer-widgets-single">
                                <h4>{t('footer.company')}</h4>
                                <ul>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.about}`}>{t('footer.about_us')}</Link>
                                    </li>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.career}`}>{t('footer.career')}</Link>
                                    </li>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.our_strength}`}>{t('footer.our_strength')}</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Single */}
                        <div className="col-lg-3 col-sm-4 col-6">
                            <div className="footer-widgets-single">
                                <h4>{t('footer.support')}</h4>
                                <ul>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.contact}`}>{t('footer.help_supprt')}</Link>
                                    </li>
                                    <li>
                                        <a href={`tel:${contactUsData?.description?.split(',')[0] || siteConfig.course_details_support_number}`}>{t('footer.hotline')}</a>
                                    </li>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}${path.faq}`}>{t('footer.faq')}</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <div className="footer-bottom">
                                <p>{t('footer.current_year', { count: returnNumberByLang(siteConfig.copyright_year) })} {t('footer.footer_copy_text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <BackToTop />
        </>
    )
}
export default Footer;